import { type TranslatedComponent, translation } from '@hh.ru/front-static-app';
import { Text, Title, VSpacingContainer } from '@hh.ru/magritte-ui';

const TrlKeys = {
    title: 'auth.twoFactor.title.accountBlocked',
    subtitle: {
        description: 'auth.twoFactor.accountBlocked.description',
        descriptionSupport: 'auth.twoFactor.accountBlocked.descriptionSupport',
    },
};

const TwoFactorAccountBlockedStep: TranslatedComponent = ({ trls }) => {
    return (
        <VSpacingContainer default={24}>
            <Title
                Element="h2"
                size="medium"
                alignment="center"
                description={
                    <VSpacingContainer default={8}>
                        <Text Element="p" typography="paragraph-2-regular" style="secondary">
                            {trls[TrlKeys.subtitle.description]}
                        </Text>
                        <Text Element="p" typography="paragraph-2-regular" style="secondary">
                            {trls[TrlKeys.subtitle.descriptionSupport]}
                        </Text>
                    </VSpacingContainer>
                }
            >
                {trls[TrlKeys.title]}
            </Title>
        </VSpacingContainer>
    );
};

export default translation(TwoFactorAccountBlockedStep);
